import React from 'react';

import { UndoButton, UndoContainer, UndoMessage } from './styles';

export interface UndoSnackbarProps {
  message: string;
  onUndo: () => void;
  closeToast?: () => void;
}

const UndoSnackbar: React.FunctionComponent<UndoSnackbarProps> = ({ message, onUndo, closeToast }) => (
  <UndoContainer>
    <UndoMessage>{message}</UndoMessage>
    <UndoButton
      type="button"
      onClick={() => {
        onUndo();
        closeToast?.();
      }}
    >
      Undo
    </UndoButton>
  </UndoContainer>
);

export default UndoSnackbar;
